import { Directive, Input } from "@angular/core";
import { KreFormAttributes, KreFormFieldConfig } from "@kre-form/core";

@Directive({
  selector: "[ionKreFormAttributes]",
  host: {
    "(keyup)": "to.keyup && to.keyup(field, $event)",
    "(keydown)": "to.keydown && to.keydown(field, $event)",
    "(click)": "to.click && to.click(field, $event)",
    "(keypress)": "to.keypress && to.keypress(field, $event)",

    "(ionChange)": "to.change && to.change(field, $event)",
    "(ionFocus)": "onFocus($event)",
    "(ionBlur)": "onBlur($event)"
  }
})
export class IonKreFormAttributes extends KreFormAttributes {
  @Input("ionKreFormAttributes") field: KreFormFieldConfig;

  focusElement(element, value: boolean) {
    if (!element.setFocus || !value) {
      return;
    }

    if (!element.getInputElement()) {
      setTimeout(() => element.setFocus(), 300);
    } else {
      element.setFocus();
    }
  }
}
